// Sentry — side-effect import. Initializes the React SDK at module load so
// any error thrown afterwards (including during initial render) is captured.
// MUST run before React renders (see main.tsx).
//
// DSN is read from VITE_SENTRY_DSN, inlined at build time by Vite. When it is
// empty/undefined (local dev, or a build without the CI secret) we never call
// Sentry.init at all — the SDK stays dormant and emits no network traffic.
//
// OTel for this portal is gated OFF by default (VITE_OTEL_ENABLED), so Sentry
// owns performance tracing here: browser tracing at a 10% sample rate. Session
// replay is disabled to keep quota low and avoid recording user sessions.

import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  try {
    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      ignoreErrors: ['ResizeObserver loop', 'ChunkLoadError', 'Network Error'],
      integrations: [Sentry.browserTracingIntegration()],
    });
  } catch (err) {
    // Never let observability wiring crash the app.
    console.warn('[sentry] init failed; continuing without error tracking', err);
  }
}
